import { useTranslation } from "react-i18next";
import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { MilestoneItem } from "./MilestoneItem";
import type { Milestone } from "./types";

type Props = {
	milestones: Milestone[];
};

export const MilestonesTimeline = ({ milestones }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box gap={14}>
			<Text variant="titleLarge">{t("lessons.stats.milestones.title")}</Text>
			<Card
				mode="outlined"
				style={{
					backgroundColor: theme.colors.surface,
					borderColor: theme.colors.outlineVariant,
					borderRadius: theme.roundness * 3,
				}}
			>
				<Card.Content
					style={{ paddingLeft: 16, paddingRight: 16, paddingVertical: 16 }}
				>
					<Box position="relative" gap={32}>
						<Box
							position="absolute"
							top={14}
							bottom={14}
							left={13}
							width={1}
							backgroundColor={theme.colors.outlineVariant}
							style={{ opacity: 0.3 }}
						/>
						{milestones.map((milestone) => (
							<MilestoneItem key={milestone.id} milestone={milestone} />
						))}
					</Box>
				</Card.Content>
			</Card>
		</Box>
	);
};
